function fetchOuQuery (id) {
  return {
    operationName: 'fetchOuQuery',
    query: `
      query fetchOuQuery($id: ID!) { organisationalUnit(id: $id) {
        id
        name: titleDe
        begin
        end
        children: subOrganisationalUnits {
          id
          name: titleDe
          begin
          end
          children: subOrganisationalUnits {
            id
            name: titleDe
            begin
            end
            }
          }
        }
      }
    `,
    variables: {
      id: Number(id) || null
    }
  }
}

export { fetchOuQuery }



// WEBPACK FOOTER //
// ./src/graphql/tree.js